'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { CartCount } from '@/components/molecule/CartCount';
import { useAuthStore } from '@/stores/AuthStore';
import { BottomSheet } from '../../../_components/BottomSheet';
import { OptionActionButtons } from '../../../_components/OptionActionButtons';
import { OptionPriceSummary } from '../../../_components/OptionPriceSummary';
import { OptionSelectBox } from '../../../_components/OptionSelectBox';
import type { ProductOption, SelectedOption } from '../types';
import { LoginPromptModal } from './LoginPromptModal';
interface DetailBottomBarProps {
  totalAmount: number;
  options: ProductOption[];
  selectedOptions: SelectedOption[];
  onSelectOption: (option: ProductOption) => void;
  onQuantityChange: (optionId: string, quantity: number) => void;
  onRemoveOption: (optionId: string) => void;
  onAddToCart?: () => void;
  isAddingToCart?: boolean;
  onBuyNow?: () => void;
  isBuyingNow?: boolean;
  socialProofCount?: number;
  isPreparing?: boolean;
  preparingLabel?: string;
}
export const DetailBottomBar = t0 => {
  const $ = _c(42);
  const {
    totalAmount,
    options,
    selectedOptions,
    onSelectOption,
    onQuantityChange,
    onRemoveOption,
    onAddToCart,
    isAddingToCart,
    onBuyNow,
    isBuyingNow,
    socialProofCount: t1,
    isPreparing,
    preparingLabel: t2
  } = t0;
  const socialProofCount = t1 === undefined ? 0 : t1;
  const preparingLabel = t2 === undefined ? "\uC0C1\uD488 \uC900\uBE44\uC911\uC774\uC5D0\uC694" : t2;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const [loginPromptDescription, setLoginPromptDescription] = useState(null);
  const isLogin = useAuthStore(_temp);
  const {
    toast: showToast
  } = useToast();
  let t3;
  if ($[0] !== socialProofCount) {
    t3 = socialProofCount > 0 ? <p className="font-700 typo-caption1"><span className="text-Gray-white">지금 이 상품을 </span><span className="text-O-400">{socialProofCount}명</span><span className="text-Gray-white">이 보고 있어요!</span></p> : null;
    $[0] = socialProofCount;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const toast = t3;
  let t4;
  if ($[2] !== isLogin || $[3] !== onAddToCart || $[4] !== options || $[5] !== selectedOptions) {
    t4 = () => {
      if (!isLogin) {
        setLoginPromptDescription("\uB85C\uADF8\uC778 \uD6C4 \uC7A5\uBC14\uAD6C\uB2C8\uC5D0 \uB2F4\uC744 \uC218 \uC788\uC5B4\uC694");
        return;
      }
      if (selectedOptions.length > 0) {
        setIsExpanded(false);
        setIsOptionOpen(false);
        onAddToCart?.();
        return;
      }
      if (options.length > 0) {
        setIsExpanded(true);
        setIsOptionOpen(true);
      }
    };
    $[2] = isLogin;
    $[3] = onAddToCart;
    $[4] = options;
    $[5] = selectedOptions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleCartClick = t4;
  let t5;
  if ($[7] !== isLogin || $[8] !== onBuyNow || $[9] !== options || $[10] !== selectedOptions) {
    t5 = () => {
      if (!isLogin) {
        setLoginPromptDescription("\uB85C\uADF8\uC778 \uD6C4 \uAD6C\uB9E4\uD560 \uC218 \uC788\uC5B4\uC694");
        return;
      }
      if (selectedOptions.length > 0) {
        setIsExpanded(false);
        setIsOptionOpen(false);
        onBuyNow?.();
        return;
      }
      if (options.length > 0) {
        setIsExpanded(true);
        setIsOptionOpen(true);
      }
    };
    $[7] = isLogin;
    $[8] = onBuyNow;
    $[9] = options;
    $[10] = selectedOptions;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const handleBuyClick = t5;
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      setIsExpanded(false);
      setIsOptionOpen(false);
    };
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const handleBackdropClick = t6;
  let t7;
  if ($[13] !== onSelectOption) {
    t7 = option => {
      onSelectOption(option);
      setIsOptionOpen(false);
    };
    $[13] = onSelectOption;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const handleOptionSelect = t7;
  let t8;
  if ($[15] !== handleBuyClick || $[16] !== handleCartClick || $[17] !== handleOptionSelect || $[18] !== isAddingToCart || $[19] !== isBuyingNow || $[20] !== isExpanded || $[21] !== isOptionOpen || $[22] !== isPreparing || $[23] !== onQuantityChange || $[24] !== onRemoveOption || $[25] !== options || $[26] !== preparingLabel || $[27] !== selectedOptions || $[28] !== showToast || $[29] !== totalAmount) {
    t8 = <div className="flex flex-col gap-12">{isPreparing ? <button type="button" disabled={true} className="flex h-56 w-full items-center justify-center bg-Gray-100 font-700 text-Gray-400 typo-body3">{preparingLabel}</button> : <><AnimatePresence>{isExpanded && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            height: {
              duration: 0.3,
              ease: "easeOut"
            },
            opacity: {
              duration: 0.2,
              delay: 0.05
            }
          }} className="overflow-hidden"><div className="flex flex-col gap-12"><OptionSelectBox options={options} isOpen={isOptionOpen} onToggle={() => setIsOptionOpen(!isOptionOpen)} onSelectOption={handleOptionSelect} onSoldOutClick={() => showToast({
                message: "\uD488\uC808\uB41C \uC0C1\uD488\uC785\uB2C8\uB2E4",
                type: "fail"
              })} />{selectedOptions.length > 0 && <div className="flex max-h-200 flex-col gap-4 overflow-y-auto">{selectedOptions.map(option_0 => <div key={option_0.optionId} className="flex flex-col gap-12 bg-Gray-25 px-16 py-12"><p className="font-400 text-Gray-900 typo-body4">{option_0.name}</p><div className="flex items-center justify-between"><CartCount count={option_0.quantity} onCountChange={count => onQuantityChange(option_0.optionId, count)} onDelete={() => onRemoveOption(option_0.optionId)} /><span className="font-500 text-Gray-900 typo-body4">{(option_0.price * option_0.quantity).toLocaleString()}원</span></div></div>)}</div>}</div><OptionPriceSummary totalAmount={totalAmount} /></motion.div>}</AnimatePresence><OptionActionButtons onCartClick={handleCartClick} onBuyClick={handleBuyClick} cartDisabled={isAddingToCart} buyDisabled={isBuyingNow} /></>}</div>;
    $[15] = handleBuyClick;
    $[16] = handleCartClick;
    $[17] = handleOptionSelect;
    $[18] = isAddingToCart;
    $[19] = isBuyingNow;
    $[20] = isExpanded;
    $[21] = isOptionOpen;
    $[22] = isPreparing;
    $[23] = onQuantityChange;
    $[24] = onRemoveOption;
    $[25] = options;
    $[26] = preparingLabel;
    $[27] = selectedOptions;
    $[28] = showToast;
    $[29] = totalAmount;
    $[30] = t8;
  } else {
    t8 = $[30];
  }
  let t9;
  if ($[31] !== isExpanded || $[32] !== t8 || $[33] !== toast) {
    t9 = <BottomSheet toast={toast} backdrop={isExpanded} onBackdropClick={handleBackdropClick}>{t8}</BottomSheet>;
    $[31] = isExpanded;
    $[32] = t8;
    $[33] = toast;
    $[34] = t9;
  } else {
    t9 = $[34];
  }
  const t10 = loginPromptDescription !== null;
  let t11;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = () => setLoginPromptDescription(null);
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  const t12 = loginPromptDescription ?? "";
  let t13;
  if ($[36] !== t10 || $[37] !== t12) {
    t13 = <LoginPromptModal opened={t10} onClose={t11} description={t12} />;
    $[36] = t10;
    $[37] = t12;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== t13 || $[40] !== t9) {
    t14 = <>{t9}{t13}</>;
    $[39] = t13;
    $[40] = t9;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  return t14;
};
function _temp(state) {
  return state.isLogin;
}